export default __webpack_public_path__ + "static/media/ValleyHuntingLodge.739a4bd5.jpg";